import { PagedZohoBookBillDetail } from './paged.zoho.book.bill.detail';

export class ZohoBookBillDtoModel {
    billNumber: string;
    total: Number;
    pagedBillLineItems: PagedZohoBookBillDetail;

    constructor() {
        this.pagedBillLineItems = new PagedZohoBookBillDetail();
    }
}
